export const getYouTubeId = (value): string => {
  const SRC_REGEX = /src="(.*?)"/im;

  const url = SRC_REGEX.test(value) ? value.match(SRC_REGEX)[1] : value;

  const { searchParams, pathname } = new URL(url);

  return searchParams.get('v') || pathname.replace('/embed', '').replace('/', '');
};
